export const ExhibitionDataLoaded = (data,type) => ({
    type: type == 'textBlock' ? 'EXHIBITION_DATA_LOADED_TEXTBLOCK' 
    : type == "eTextBlock" ? "EXHIBITION_DATA_LOADED_ETEXTBLOCK" 
    : type == "floorPlan" ? "EXHIBITION_DATA_LOADED_FLOORPLAN" : "EXHIBITION_DATA_LOADED_EXHIBITORS",
    payload : data
})